const MyLabel = ({ logo, label, marginBottom = '8px', marginLeft = '0px' }) => {
  return (
    <div style={{ color: 'white', height: '30px', display: 'flex', alignItems: 'center', marginBottom: marginBottom, marginLeft: marginLeft }}>
      {logo !== '' && <img src={logo} alt="label" style={{ height: '30px' }} />}
      <span style={{ marginLeft: '10px', fontWeight: 600 }}>{label}</span>
    </div>
  );
};

export default MyLabel;
